/** TabTrips Extranet native app store links. */
export const ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.tabtrips.extranet&pcampaignid=web_share';

export const IOS_APP_URL =
  'https://apps.apple.com/in/app/tabtrips-extranet/id6789814070';

/** Production extranet host — QR / share links must use this, never localhost. */
export const EXTRANET_ORIGIN = 'https://extranet.tabtrips.com';

export function detectMobilePlatform(userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  const ua = String(userAgent || '');
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  // iPadOS 13+ may report as Mac with touch
  if (typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

export function getStoreUrlForPlatform(platform) {
  if (platform === 'ios') return IOS_APP_URL;
  if (platform === 'android') return ANDROID_APP_URL;
  return null;
}

/** Absolute smart-link URL encoded in the QR (always production). */
export function getAppRedirectUrl() {
  return `${EXTRANET_ORIGIN}/get-app`;
}
